import { IPersonalInfo } from 'types';
import { countries } from 'data';

export const getCountryOfVisaApplication = (personalInfo: IPersonalInfo): string | undefined => {
  if (personalInfo.applyingFromHomeCountry) {
    return countries.find(i => i.nationality === personalInfo.nationality)?.countryName ?? undefined;
  }

  if (personalInfo.countryOfVisaApplication) return personalInfo.countryOfVisaApplication;

  return countries.find(i => i.nationality === personalInfo.nationality)?.countryName ?? undefined;
};
